import { GroupMemberAdapter } from '../../../app/groups';
import { GroupsMemberImplConfig } from './groupMemberConfig';

export function createGroupsMemberImpl(
    config: GroupsMemberImplConfig
): GroupMemberAdapter {
    const { api } = config;
    return {
        async find(context, query) {
            const response = await api.members.list(context, query);

            let acc = response.data;
            return {
                limit: query.pageSize,
                total: response.pagination?.count || acc.length,
                items: acc,
            };
        },
        bulkUpsert(context, payload) {
            return api.members.bulkUpsert(context, payload);
        },
    };
}
